import React from 'react';
import { Icon } from "semantic-ui-react";

function TheIcon (props) {
  return <Icon name="object ungroup outline" {...props} />;
}

export const meta = {
  id: 'ManageDataGroups',
  title: 'ManageDataGroups',
  category: '',
  // exposes: [
  //   {
  //     title: 'General',
  //     action: { module: 'ManageDataGroups', props: { /* */ } },
  //     desription: 'general-desc',
  //   },
  // ],
  unique: true,
  icon: TheIcon,
  version: '1.0.0',
  description: `Allows you to manage DGs`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    // width: 630,
    // height: 380
  }
};
